module.exports = __webpack_public_path__ + "img/6.d67f651a.png";